import React, { Component } from 'react';
import AppBar from './AppBar';
import VirtualizedList from './VirtualizedList';
import { IPedido, IFarm, IFilter } from '../types';
import SearchField from './SearchField';
import OrderService from '../ApiClients/OrderService';
import PedidoListItem from './PedidoListItem';
import Loader from './Loader';
import { CheckNumberPlate, searchPedidos } from '../helpers';
import {cloneDeep, filter, find, findIndex, includes} from 'lodash';
import { SwitchField } from './FormsWidgets';
import { Box, Tab, Tabs, Select, InputLabel, MenuItem, SelectChangeEvent, FormControl, Button, IconButton, Tooltip, Collapse, Autocomplete, TextField, CircularProgress } from '@mui/material';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import { withParamsAndNavigate } from './Material/ReactRouter';
import CreateModal from './CreateDialog';
import DeliveryDialog from './DeliveryDialog';
import { relative } from 'path';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import esLocale from "date-fns/locale/es";
import farmIcon from '../Assets/farm.png';
import CategoryIcon from '@material-ui/icons/CategoryOutlined';
import RefreshIcon from '@material-ui/icons/Refresh';
import SearchIcon from '@material-ui/icons/Search';

interface IPedidosProps {
    params?:any;
    navigate?:any;    
    type: number;
    title: string;
    filters: IFilter;
    handleChangeFilter: Function;
}

interface IPedidosState {
    pedidos?: Array<IPedido>;
    pedidosHistorico?: Array<IPedido>;
    searchValue: string;
    loading: boolean;
    loadingHistorico: boolean;
    filteredPedidos: Array<IPedido>;
    filterPage: Object;
    tabPedidos: number;

    openDeliveryDialog: boolean;
    inputDeliveryDialog: any;
    titleModal: string;
    loadingModal: boolean;
    modalType: number;
    typeAction: number;
    inputText: string;
    creationModalOpen: boolean;

    tPedido?:IPedido;

    pendientes:boolean;
    firstView:boolean;
    plate:string;
    inset_content:string;
    filter_id: string;

    // Filtros para histórico
    historicoDateFrom: Date;
    historicoDateTo: Date;
    historicoGranja: string;
    historicoLote: string;
    historicoAgrupado: string; // 'pedido' | 'granja' | 'lote'
    
    // Datos de filtros disponibles
    historicoGranjas: Array<{id: string, business: string, name: string}>;
    historicoLotesDisponibles: Array<{batchId: string, farmId: string, business: string}>;
    
    // Filtros aplicados (los que realmente se usaron en la última búsqueda)
    historicoGranjaAplicada: string;
    historicoLoteAplicado: string;
    historicoDateFromAplicada: Date;
    historicoDateToAplicada: Date;
    
    // Control de grupos expandidos
    expandedGroups: Set<string>;
}

class Pedidos extends Component<IPedidosProps, IPedidosState> {
    constructor(props: IPedidosProps) {
        super(props);
        
        // Por defecto últimos 5 años
        const now = new Date();
        const fiveYearsAgo = new Date();
        fiveYearsAgo.setFullYear(fiveYearsAgo.getFullYear() - 5);

        this.state = {
            pedidos: undefined,
            pedidosHistorico: undefined,
            filteredPedidos:[],
            searchValue: '',
            loading: true,
            loadingHistorico: false,
            filterPage: {historic: false},
            tabPedidos: 0,

            openDeliveryDialog: false,
            inputDeliveryDialog: '',
            titleModal: 'MENSAJE',
            loadingModal: false,
            modalType: 0,
            typeAction: 0,
            creationModalOpen: false,
            inputText: '',

            pendientes:true,
            plate:'',
            firstView:true,
            inset_content:'60px 0 0',
            filter_id: "f_do",

            historicoDateFrom: fiveYearsAgo,
            historicoDateTo: now,
            historicoGranja: '',
            historicoLote: '',
            historicoAgrupado: 'pedido',
            
            historicoGranjas: [],
            historicoLotesDisponibles: [],
            
            historicoGranjaAplicada: '',
            historicoLoteAplicado: '',
            historicoDateFromAplicada: fiveYearsAgo,
            historicoDateToAplicada: now,
            
            expandedGroups: new Set<string>()
        };
    }
   
    onCloseCreationModal = () => {
        this.setState({ creationModalOpen: false });
    }

    onCloseDeliveryDialog = () => {
        this.setState({ openDeliveryDialog: false });
    }

    componentDidMount() {
        this.loadPedidos();
    }

    componentWillReceiveProps(nextProps: IPedidosProps) {
        // Si cambia el tipo de pedido, necesitamos recargar
        if (nextProps.type !== this.props.type) {
            this.setState({ 
                loading: true 
            }, () => this.loadPedidos());
        }
    }

    handleChangeFilter=(id:string, evt:any)=>{
        let newFilters = cloneDeep(this.props.filters[this.state.filter_id]);
        newFilters[id] = evt.target.value;

        this.props.handleChangeFilter(this.state.filter_id, newFilters, false);
    }

    loadPedidos = async () => {
        // Usar patrón como Farms: OrderService maneja la cache internamente
        let pedidos = await OrderService.getPedidos(false, this.props.type);
        
        if (pedidos !== undefined) {
            this.setState({
                pedidos,
                loading: false,
                searchValue: ('searchbar' in this.props.filters[this.state.filter_id])? this.props.filters[this.state.filter_id]['searchbar'] : '',
                plate: ('deliveryTruckNumberplate' in this.props.filters[this.state.filter_id])? this.props.filters[this.state.filter_id]['deliveryTruckNumberplate'] : '',
                firstView: !('deliveryTruckNumberplate' in this.props.filters[this.state.filter_id]),
            }, ()=>{
                this.handleFilterPedidos();
            });
        } else {
            this.setState({ loading: false });
        }
    }

    loadPedidosWithRefresh = async () => {
        // Forzar refresh desde servidor después de editar
        let pedidos = await OrderService.getPedidos(true, this.props.type);
        
        if (pedidos !== undefined) {
            this.setState({
                pedidos,
                loading: false,
                searchValue: ('searchbar' in this.props.filters[this.state.filter_id])? this.props.filters[this.state.filter_id]['searchbar'] : '',
                plate: ('deliveryTruckNumberplate' in this.props.filters[this.state.filter_id])? this.props.filters[this.state.filter_id]['deliveryTruckNumberplate'] : '',
                firstView: !('deliveryTruckNumberplate' in this.props.filters[this.state.filter_id]),
            }, ()=>this.handleFilterPedidos());
        }
    }

    loadPedidosHistorico = async () => {
        // Guardar los filtros que se van a aplicar ANTES de hacer la petición
        const granjaAplicada = this.state.historicoGranja;
        const loteAplicado = this.state.historicoLote;
        const dateFromAplicada = this.state.historicoDateFrom;
        const dateToAplicada = this.state.historicoDateTo;
        
        this.setState({ loadingHistorico: true });
        
        const response = await OrderService.getPedidosHistorico(
            dateFromAplicada,
            dateToAplicada,
            granjaAplicada || undefined,
            loteAplicado || undefined
        );
        
        // Asegurar que los datos sean arrays válidos
        const pedidos = Array.isArray(response?.pedidos) ? response.pedidos : [];
        const granjas = Array.isArray(response?.granjas) ? response.granjas : this.state.historicoGranjas;
        const lotes = Array.isArray(response?.lotes) ? response.lotes : this.state.historicoLotesDisponibles;
        
        // Si solo hay una granja disponible y no hay granja seleccionada, preseleccionarla
        const soloUnaGranja = !granjaAplicada && granjas.length === 1;
        const granjaPreseleccionada = soloUnaGranja ? granjas[0].id : granjaAplicada;
        
        this.setState({
            pedidosHistorico: pedidos,
            historicoGranjas: granjas,
            historicoLotesDisponibles: lotes,
            loadingHistorico: false,
            // Preseleccionar granja si solo hay una (solo visual, el usuario debe dar a Aplicar)
            historicoGranja: granjaPreseleccionada,
            // Guardar los filtros que realmente se aplicaron en la petición
            historicoGranjaAplicada: granjaAplicada,
            historicoLoteAplicado: loteAplicado,
            historicoDateFromAplicada: dateFromAplicada,
            historicoDateToAplicada: dateToAplicada
        }, () => {
            this.handleFilterPedidos();
            // Si solo hay una granja, aplicar el filtro automáticamente después de la carga inicial
            if (soloUnaGranja) {
                this.handleBuscarHistorico();
            }
        });
    }

    handleHistoricoDateFromChange = (date: MaterialUiPickersDate) => {
        if (date) {
            this.setState({ historicoDateFrom: date });
        }
    }

    handleHistoricoDateToChange = (date: MaterialUiPickersDate) => {
        if (date) {
            this.setState({ historicoDateTo: date });
        }
    }

    handleBuscarHistorico = () => {
        // Limpiar datos anteriores y recargar con nuevos filtros
        this.setState({ pedidosHistorico: undefined }, () => {
            this.loadPedidosHistorico();
        });
    }

    handleLimpiarFiltrosHistorico = () => {
        // Resetear filtros a valores por defecto (último mes, sin filtros de granja/lote)
        const now = new Date();
        const fiveYearsAgo = new Date();
        fiveYearsAgo.setFullYear(fiveYearsAgo.getFullYear() - 5);

        this.setState({ 
            historicoGranja: '',
            historicoLote: '',
            historicoDateFrom: fiveYearsAgo,
            historicoDateTo: now,
            pedidosHistorico: undefined
        }, () => {
            this.loadPedidosHistorico();
        });
    }

    handleHistoricoGranjaChange = (event: any, newValue: {id: string, business: string, name: string} | null) => {
        // Al cambiar granja, limpiar lote seleccionado
        this.setState({ 
            historicoGranja: newValue?.id || '',
            historicoLote: '' 
        });
    }

    handleHistoricoLoteChange = (event: any, newValue: {batchId: string, farmId: string, business: string} | null) => {
        this.setState({ historicoLote: newValue?.batchId || '' });
    }

    handleHistoricoAgrupadoChange = (event: SelectChangeEvent) => {
        // Al cambiar agrupación, resetear grupos expandidos
        this.setState({ 
            historicoAgrupado: event.target.value,
            expandedGroups: new Set<string>()
        }, () => {
            this.handleFilterPedidos();
        });
    }

    handleToggleGroup = (groupId: string) => {
        this.setState(prevState => {
            const newExpanded = new Set(prevState.expandedGroups);
            if (newExpanded.has(groupId)) {
                newExpanded.delete(groupId);
            } else {
                newExpanded.add(groupId);
            }
            return { expandedGroups: newExpanded };
        });
    }

    isGroupExpanded = (groupId: string): boolean => {
        // Por defecto expandido si no está en el Set (Set vacío = todos expandidos por defecto)
        // Si el grupo está en expandedGroups, significa que fue colapsado manualmente
        return !this.state.expandedGroups.has(groupId);
    }

    getDescripcionResultados = () => {
        const { 
            pedidosHistorico, 
            historicoGranjaAplicada, 
            historicoLoteAplicado, 
            historicoGranjas,
            historicoDateFromAplicada,
            historicoDateToAplicada 
        } = this.state;
        
        if (!pedidosHistorico || pedidosHistorico.length === 0) return '';

        const count = pedidosHistorico.length;
        let descripcion = `Mostrando ${count} pedido${count !== 1 ? 's' : ''}`;

        // Si no hay filtros de granja ni lote
        if (!historicoGranjaAplicada && !historicoLoteAplicado) {
            descripcion += ' en todas las granjas y lotes';
        } else {
            // Obtener nombre de la granja si se aplicó filtro de granja
            if (historicoGranjaAplicada) {
                const granja = historicoGranjas.find(g => g.id === historicoGranjaAplicada);
                if (granja) {
                    descripcion += ` de la granja "${granja.name}"`;
                }
            }

            // Añadir lote si se aplicó filtro de lote
            if (historicoLoteAplicado) {
                descripcion += `${historicoGranjaAplicada ? ' y' : ''} del lote "${historicoLoteAplicado}"`;
            }
        }

        // Añadir rango de fechas
        const formatDate = (date: Date) => date.toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' });
        descripcion += ` (${formatDate(historicoDateFromAplicada)} - ${formatDate(historicoDateToAplicada)})`;

        return descripcion;
    }


    // Renderizar un pedido individual para la vista agrupada
    renderPedidoItem = (pedido: IPedido, index: number) => {
        return (
            <div 
                key={pedido.id} 
                onClick={() => this.handleItemClick(pedido, index)} 
                style={{ 
                    cursor: 'pointer',
                    borderRadius: '15px',
                    margin: '5px 10px',
                    boxShadow: '5px 5px 5px 0px rgba(0,0,0,0.31)',
                    border: `2px solid ${pedido.orderColor || '#ccc'}`,
                    padding: '10px 15px',
                    position: 'relative',
                    color: '#284770',
                    backgroundColor: 'white'
                }}
            >
                <div style={{ fontWeight: 'bold' }}>{pedido.farm?.name || 'Sin granja'}</div>
                <div style={{ fontSize: '12px', color: '#666' }}>
                    <span>Usuario: {pedido.userOrder}</span><br />
                    <span>Fecha entrega: {pedido.date ? new Date(pedido.date).toLocaleDateString('es-ES') : '-'}</span><br />
                    <span>Num. Pedido: {pedido.idPedido}</span><br />
                    <span>Empresa: {pedido.business}</span>
                </div>
                <div style={{
                    position: 'absolute',
                    bottom: '10px',
                    right: '15px',
                    borderRadius: '10px',
                    padding: '5px 10px',
                    fontSize: '11px',
                    backgroundColor: pedido.statusColor || '#ccc',
                    color: '#ffffff'
                }}>
                    {pedido.statusDsc}
                </div>
            </div>
        );
    }

    // Renderizar pedidos agrupados por granja o lote
    renderPedidosAgrupados = (pedidos: Array<IPedido>, agrupacion: string) => {
        if (agrupacion === 'granja') {
            // Agrupar por granja
            const grupos = new Map<string, { nombre: string, pedidos: Array<IPedido> }>();
            pedidos.forEach((pedido) => {
                const granjaId = pedido.farm?.id || 'sin-granja';
                const granjaNombre = pedido.farm?.name || 'Sin granja';
                if (!grupos.has(granjaId)) {
                    grupos.set(granjaId, { nombre: granjaNombre, pedidos: [] });
                }
                grupos.get(granjaId)!.pedidos.push(pedido);
            });

            return (
                <div style={{ overflow: 'auto', height: '100%', padding: '10px' }}>
                    {Array.from(grupos.entries()).map(([granjaId, grupo]) => {
                        const isExpanded = this.isGroupExpanded(granjaId);
                        return (
                            <div key={granjaId} style={{ marginBottom: '20px' }}>
                                <div 
                                    onClick={() => this.handleToggleGroup(granjaId)}
                                    style={{
                                        backgroundColor: '#284770',
                                        color: 'white',
                                        padding: '10px 15px',
                                        borderRadius: isExpanded ? '8px 8px 0 0' : '8px',
                                        fontWeight: 'bold',
                                        fontSize: '14px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '10px',
                                        cursor: 'pointer',
                                        transition: 'border-radius 0.3s ease'
                                    }}
                                >
                                    <img src={farmIcon} alt="granja" style={{ width: '24px', height: '24px' }} />
                                    <span style={{ flex: 1 }}>{grupo.nombre} ({grupo.pedidos.length} pedidos)</span>
                                    {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                </div>
                                <Collapse in={isExpanded}>
                                    <div style={{ border: '1px solid #ddd', borderTop: 'none', borderRadius: '0 0 8px 8px', backgroundColor: '#f9f9f9' }}>
                                        {grupo.pedidos.map((pedido, i) => this.renderPedidoItem(pedido, i))}
                                    </div>
                                </Collapse>
                            </div>
                        );
                    })}
                </div>
            );
        } else if (agrupacion === 'lote') {
            // Agrupar por lote
            const grupos = new Map<string, { granjaNombre: string, pedidos: Array<IPedido> }>();
            pedidos.forEach((pedido) => {
                const lotes = pedido.products?.map((p: any) => p.batchId).filter(Boolean) || ['sin-lote'];
                lotes.forEach((lote: string) => {
                    if (!grupos.has(lote)) {
                        // Guardar el nombre de la granja del primer pedido del lote
                        grupos.set(lote, { granjaNombre: pedido.farm?.name || 'Sin granja', pedidos: [] });
                    }
                    // Evitar duplicados
                    if (!grupos.get(lote)!.pedidos.find(p => p.id === pedido.id)) {
                        grupos.get(lote)!.pedidos.push(pedido);
                    }
                });
            });

            return (
                <div style={{ overflow: 'auto', height: '100%', padding: '10px' }}>
                    {Array.from(grupos.entries()).sort().map(([lote, grupo]) => {
                        const isExpanded = this.isGroupExpanded(lote);
                        return (
                            <div key={lote} style={{ marginBottom: '20px' }}>
                                <div 
                                    onClick={() => this.handleToggleGroup(lote)}
                                    style={{
                                        backgroundColor: '#284770',
                                        color: 'white',
                                        padding: '10px 15px',
                                        borderRadius: isExpanded ? '8px 8px 0 0' : '8px',
                                        fontWeight: 'bold',
                                        fontSize: '14px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '10px',
                                        cursor: 'pointer',
                                        transition: 'border-radius 0.3s ease'
                                    }}
                                >
                                    <CategoryIcon style={{ fontSize: '24px' }} />
                                    <span>Lote: {lote}</span>
                                    <span style={{ opacity: 0.8, fontWeight: 'normal' }}>|</span>
                                    <img src={farmIcon} alt="granja" style={{ width: '20px', height: '20px' }} />
                                    <span style={{ fontWeight: 'normal' }}>{grupo.granjaNombre}</span>
                                    <span style={{ flex: 1 }}></span>
                                    <span style={{ fontSize: '12px', opacity: 0.9 }}>({grupo.pedidos.length} pedidos)</span>
                                    {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                </div>
                                <Collapse in={isExpanded}>
                                    <div style={{ border: '1px solid #ddd', borderTop: 'none', borderRadius: '0 0 8px 8px', backgroundColor: '#f9f9f9' }}>
                                        {grupo.pedidos.map((pedido, i) => this.renderPedidoItem(pedido, i))}
                                    </div>
                                </Collapse>
                            </div>
                        );
                    })}
                </div>
            );
        }

        return null;
    }

    handleValueChange = (evt: any) => {
        // Guardar filtro en estado global como hacen Farms y Products
        let newFilters = cloneDeep(this.props.filters[this.state.filter_id]);
        newFilters["searchbar"] = evt.target.value;

        this.props.handleChangeFilter(this.state.filter_id, newFilters, false);

        this.setState({ 
            searchValue: evt.target.value,
        }, ()=>this.handleFilterPedidos())
    }

    handleFilterPedidos = () => {
        const tabPedidos = this.state.tabPedidos;
        
        // Tab Histórico (solo para type 1)
        if (tabPedidos === 2 && this.props.type === 1) {
            if (this.state.pedidosHistorico === undefined) {
                this.setState({
                    filteredPedidos: [],
                    pendientes: false,
                    inset_content: '0 0 0'
                });
                return;
            }
            let newPedidos = cloneDeep(this.state.pedidosHistorico);

            //** FILTRA PARA EXCLUIR DEVOLUCIONES (moveType 2) */
            newPedidos = filter(newPedidos, function(o) { return o.moveType !== 2; });

            //** FILTRA POR EL VALOR DE BÚSQUEDA (solo en frontend) */
            const searchValue = this.state.searchValue.toLowerCase();
            let newFilters = cloneDeep(this.props.filters[this.state.filter_id]);
            newFilters["searchbar"] = searchValue;
            this.props.handleChangeFilter(this.state.filter_id, newFilters, false);

            if(newPedidos.length > 0 && searchValue && searchValue.length > 0){
                newPedidos = filter(newPedidos, function(o){return includes(o.farm?.id.toLowerCase(), searchValue) || includes(o.farm?.name.toLowerCase(), searchValue) || includes(o.idPedido?o.idPedido.toLowerCase():"", searchValue) });
            }

            this.setState({
                filteredPedidos: newPedidos,
                pendientes: false,
                inset_content: '0 0 0'
            });
            return;
        }

        // Solo filtrar si hay datos cargados
        if (this.state.pedidos === undefined) {
            return;
        }
        
        let newPedidos = cloneDeep(this.state.pedidos);
        
        //** FILTRA POR EL TIPO DE PEDIDO */
        const tipo = this.props.type;

        //** FILTRA PARA EXCLUIR RETIRADAS (moveType 2) EN VISTA PEDIDOS */
        if (tipo === 1) {
            newPedidos = filter(newPedidos, function(o) { return o.moveType !== 2; });
        }
        let newFilters = cloneDeep(this.props.filters[this.state.filter_id]);
        this.setState({pendientes: tabPedidos === 
            0, inset_content: (tabPedidos === 0) ? '60px 0 0': '0 0 0'});
        
        if(tipo === 1 && tabPedidos === 0) {
            newPedidos = filter(newPedidos, function(o) {return ![50, 98, 99].includes(o.status)})
        } else if(tipo === 2 && tabPedidos === 0) {
            newPedidos = filter(newPedidos, function(o) {return ![50, 98, 99].includes(o.status)})
    
            //** FILTRA POR EL VALOR DE MATRÍCULA */
            const plate = this.state.plate;
            
            newFilters["deliveryTruckNumberplate"] = plate;

            this.props.handleChangeFilter(this.state.filter_id, newFilters, false);

            if(newPedidos.length > 0 && plate && plate !== 'Matrícula sin asignar'){
                newPedidos = filter(newPedidos, function(o){return includes(o.deliveryTruckNumberplate, plate)});
            }else if(plate === 'Matrícula sin asignar'){            
                newPedidos = filter(newPedidos, function(o){return o.deliveryTruckNumberplate === ""});
            }
        }
                
        //** FILTRA POR EL VALOR DE BÚSQUEDA */
        const searchValue = this.state.searchValue.toLowerCase();
        
        newFilters["searchbar"] = searchValue;

        this.props.handleChangeFilter(this.state.filter_id, newFilters, false);

        if(newPedidos.length > 0 && searchValue && searchValue.length > 0){
            newPedidos = filter(newPedidos, function(o){return includes(o.farm?.id.toLowerCase(), searchValue) || includes(o.farm?.name.toLowerCase(), searchValue) || includes(o.idPedido?o.idPedido.toLowerCase():"", searchValue) });
        }

        this.setState({
            filteredPedidos: newPedidos
        })
    }

    handleItemClick = (pedido: IPedido, i: number) => {
        const pedidoRef = (pedido as any).idPedido ?? String((pedido as any).id ?? '');
        if(this.props.type === 1)
            this.props.navigate(`/pedido/${pedido.business}/${pedidoRef}`);
        else if(this.props.type === 2)
            this.props.navigate(`/delivery/${pedido.business}/${pedidoRef}`);
    }

    handleItemEditClick = (e: any, pedido: IPedido, i: number) => {
        e.stopPropagation();

        this.setState({
            tPedido: pedido
        }, ()=>this.handleEditPedido())
    }

    handleEditPedido = () => {
        if(!this.state.tPedido)
            return;

        let n_pedido = cloneDeep(this.state.tPedido);

        n_pedido.handleChange = (id: string, evt: any) => this.handleHeaderChange(id, evt, n_pedido);


        this.setState({
            titleModal:'EDICIÓN DATOS',
            inputDeliveryDialog: <DeliveryDialog style={{}} index={-1} data={[2, n_pedido]} />,
            modalType: 5,
            typeAction: 1,
            openDeliveryDialog: true
        })
    }

    handleHeaderChange = (id: string, evt: any, pedido:IPedido) => {
        let n_pedido = cloneDeep(pedido);
        n_pedido[id] = evt.target.value;

        if(id === "deliveryTruckNumberplate" || id === "deliveryTrailerNumberplate")
            n_pedido[id] = n_pedido[id]?.trim().toUpperCase();

        this.setState({
            tPedido: n_pedido
        }, ()=>this.handleEditPedido())
    }

    saveEditPedido = async () => {
        const {tPedido} = this.state;
        // Verifica que la tienda y la fecha del carrito no sean undefined
        if(tPedido && tPedido.farm && tPedido.date && tPedido.id) {
            let Pedido: IPedido = cloneDeep(tPedido);

            let responsePedido : number = await OrderService.saveData(Pedido, 3);

            let text = "¡ATENCIÓN! Se ha producido un error y no se han podido actualizar los datos del pedido.";
            let modalType = 1;
            let typeAction = -1;

            switch(responsePedido){ // Condicional para verificar que no ha habido ningun error en el backend
                case 1:
                    text = "Se ha actualizado correctamente.";
                    modalType = 1;
                    typeAction = 0;

                    // Forzar recarga de datos después de editar
                    this.setState({
                        inputText: text,
                        modalType: modalType,
                        creationModalOpen: true,
                        typeAction:typeAction,
                        loadingModal: false,
                        openDeliveryDialog: false,
                        loading: true,
                        pedidos: undefined  // Forzar nueva petición
                    });
                    // Forzar refresh en OrderService para obtener datos actualizados del servidor
                    this.loadPedidosWithRefresh();
                    break;
                default: 
                    this.setState({
                        inputText: text,
                        modalType: modalType,
                        creationModalOpen: true,
                        typeAction:typeAction,
                        loadingModal: false,
                        openDeliveryDialog: false,
                    })
                    break;
            }

        } 
    }

    handleCreateModal = (typeAction: number) => {
        switch(typeAction) {
            case 1: // Cuando el modal es para abrir el modal de actualizar datos
                const {tPedido} = this.state;

                if(tPedido && tPedido.farm){
                    // Controla los campos obligatorios
                    if(!tPedido.deliveryTruckNumberplate || !CheckNumberPlate(1, tPedido.deliveryTruckNumberplate))
                        this.setState({
                            inputText: `¡ATENCIÓN! Tiene que informar una matrícula de camión válida.`,
                            modalType: 1,
                            creationModalOpen: true,
                            typeAction: -1
                        })
                    else if(!tPedido.deliveryTrailerNumberplate || !CheckNumberPlate(2, tPedido.deliveryTrailerNumberplate))
                        this.setState({
                            inputText: `¡ATENCIÓN! Tiene que informar una matrícula de remolque válida.`,
                            modalType: 1,
                            creationModalOpen: true,
                            typeAction: -1
                        })
                    else
                    this.setState({
                        inputText: `¿Quiere actualizar los datos del pedido de la granja ${tPedido.farm.name}?`,
                        modalType: 2,
                        creationModalOpen: true,
                        typeAction: 2
                    })
                }
                break;
            case 2: // Cuando el modal es para guardar los datos actualizados
                this.setState({
                    loadingModal: true
                }, ()=>this.saveEditPedido())
                break;
            default:
                break;
        }
    }
    

    handleChangePlate = (event: SelectChangeEvent) => {      
        // Solo filtrar si hay datos cargados
        if (this.state.pedidos === undefined) {
            return;
        }
                  
        let newPedidos = cloneDeep(this.state.pedidos);
        const searchValue = event.target.value;

        let newFilters = cloneDeep(this.props.filters[this.state.filter_id]);
        newFilters["deliveryTruckNumberplate"] = searchValue;

        this.props.handleChangeFilter(this.state.filter_id, newFilters, false);

        if(newPedidos.length > 0 && searchValue && searchValue !== 'Matrícula sin asignar'){
            newPedidos = filter(newPedidos, function(o){return includes(o.deliveryTruckNumberplate, searchValue)});
        }else if(searchValue === 'Matrícula sin asignar'){            
            newPedidos = filter(newPedidos, function(o){return o.deliveryTruckNumberplate === ""});
        }

        this.setState({
            filteredPedidos: newPedidos,
            plate: searchValue, 
            firstView: false
        }, ()=>this.handleFilterPedidos())
    };

    renderPedidos=(type:number)=>{
        // Loading para tab histórico
        if(this.state.tabPedidos === 2 && this.state.loadingHistorico){
            return(
                <div style={{marginLeft:'50%',marginTop:200}}>
                    <Loader loading={true}/>
                </div>
            );
        }
        
        if(this.state.loading){
            return(
                <div style={{marginLeft:'50%',marginTop:200}}>
                    <Loader loading={true}/>
                </div>
            );
        }
        else if(type === 1) {
            const {filteredPedidos, tabPedidos, historicoAgrupado} = this.state;

            if(filteredPedidos.length === 0) {
                let mensaje = 'No tiene pedidos realizados para visualizar.';
                if (tabPedidos === 2) {
                    mensaje = 'No tiene pedidos en el histórico para visualizar.';
                }
                return (
                    <div style={{textAlign:'center', padding:50}}>
                        <p>
                            {mensaje}
                        </p>
                    </div>
                )
            }

            // Si estamos en histórico y hay agrupación seleccionada
            if (tabPedidos === 2 && historicoAgrupado !== 'pedido') {
                return this.renderPedidosAgrupados(filteredPedidos, historicoAgrupado);
            }

            let items = filteredPedidos.map((pedido, i) => {
                return {
                    ...pedido,
                    onItemClick: () => this.handleItemClick(pedido, i),
                }
            })
            return(
                <VirtualizedList items={items} RowComponent={PedidoListItem} itemSize={150} />
            );
        }
        else if(type === 2) {
            const {filteredPedidos} = this.state;
            let items = filteredPedidos.map((pedido, i) => {
                return {
                    ...pedido,
                    onItemClick: () => this.handleItemClick(pedido, i),
                    onItemEditClick: (e:any) => this.handleItemEditClick(e, pedido, i),
                }
            })
            
            // Verificar que pedidos no sea undefined antes de hacer map
            let plates: string[] = [];
            if (this.state.pedidos !== undefined) {
                plates = this.state.pedidos.map((item: IPedido, i: number) => {
                    return item.deliveryTruckNumberplate === "" ? "Matrícula sin asignar" : (item.deliveryTruckNumberplate || "");
                });
            }
            let numberPlates = plates.filter((plate, index) => plates.indexOf(plate) === index);
            
            if(filteredPedidos.length === 0) {
                if(this.state.tabPedidos === 0){
                    return(
                        <div style={{ marginLeft:'10px' }}>{(this.state.pendientes) ?
                            <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }} style={{ marginLeft:'10px', marginTop:'5px' }}>
                                <InputLabel id="matricula-label">Matrícula</InputLabel>
                                <Select labelId="matricula-label" id="matricula" value={(numberPlates.length === 1) ? numberPlates[0]: this.state.plate} onChange={this.handleChangePlate} label="Matrícula"> 
                                {/* <MenuItem value="todos">Mostrar todas</MenuItem>                      */}
                                {numberPlates.map((item, i) =>{                            
                                        return <MenuItem value={item}>{item}</MenuItem>;
                                })}                    
                                </Select>
                            </FormControl> : null
                            }                    
                            <div style={{ position:'absolute', inset: this.state.inset_content }}>
                            <div style={{textAlign:'center', padding:50}}>
                                <p>
                                    {`No tiene pedidos pendientes de entregar para visualizar.`}
                                </p>
                            </div>
                            </div>
                        </div>
                    );
                }else if(this.state.tabPedidos === 1)
                    return (
                        <div style={{textAlign:'center', padding:50}}>
                            <p>
                                {`No tiene pedidos pendientes de entregar o entregados para visualizar.`}
                            </p>
                        </div>
                    )
                else
                    return (
                        <div style={{textAlign:'center', padding:50}}>
                            <p>
                                {`No hay datos a visualizar.`}
                            </p>
                        </div>
                    )
            }

            
            if (this.state.firstView && numberPlates.length > 1){       
                return(
                        <div>{
                            (this.state.pendientes) ?
                            <div style={{ position:'absolute', top:'50%', left:'50%', transform:'translate(-50%,-50%)' }}>
                                <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
                                    <InputLabel id="matricula-label">Matrícula</InputLabel>
                                    <Select labelId="matricula-label" id="matricula" value={this.state.plate} onChange={this.handleChangePlate} label="Matrícula">
                                            {numberPlates.map((item, i) =>{                            
                                                return <MenuItem value={item}>{item}</MenuItem>;
                                                })}                    
                                    </Select>
                                </FormControl>
                            </div> : 
                            <div style={{ position:'absolute', inset: this.state.inset_content }}>
                                <VirtualizedList items={items} RowComponent={PedidoListItem} itemSize={170} />
                            </div>
                        }</div>
                        
                    );
            }else{
                return(
                    <div style={{ marginLeft:'10px' }}>{(this.state.pendientes) ?
                        <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }} style={{ marginLeft:'10px', marginTop:'5px' }}>
                            <InputLabel id="matricula-label">Matrícula</InputLabel>
                            <Select labelId="matricula-label" id="matricula" value={(numberPlates.length === 1) ? numberPlates[0]: this.state.plate} onChange={this.handleChangePlate} label="Matrícula"> 
                            {numberPlates.map((item, i) =>{                            
                                    return <MenuItem value={item}>{item}</MenuItem>;
                            })}                    
                            </Select>
                        </FormControl> : null
                        }                    
                        <div style={{ position:'absolute', inset: this.state.inset_content }}>
                            <VirtualizedList items={items} RowComponent={PedidoListItem} itemSize={170} />
                        </div>
                    </div>
                );
            }
            
        }
    }

    handleSwichChangeUser=(id:string, evt:any)=>{
        let newRegister:any = cloneDeep(this.state.filterPage);
        newRegister[id] = evt.target.checked;
        this.setState({filterPage:newRegister});
    }

    handleChangeTab = (event: React.SyntheticEvent, newValue: number) => {
        this.setState({
            tabPedidos: newValue
        }, () => {
            // Si selecciona tab Histórico (2) y es type 1, cargar pedidos con filtros por defecto
            if (newValue === 2 && this.props.type === 1) {
                // Solo cargar si no hay datos previos
                if (!this.state.pedidosHistorico) {
                    this.loadPedidosHistorico();
                } else {
                    this.handleFilterPedidos();
                }
            } else {
                this.handleFilterPedidos();
            }
        });
    };

    render() {

        const {type, title} = this.props;
        const {tabPedidos} = this.state;

        return (
            <AppBar title={title} navigate={this.props.navigate}>
                {/* <div style={{ paddingTop: '10px' }}>
                    <SearchField allowSearch={this.state.loading} value={this.state.searchValue} onValueChange={this.handleValueChange} placeholder="Buscar Pedido" />
                </div> */}
                <div style={{ paddingTop: '15px' }}>
                    <table style={{width:'100%'}}>
                        <tbody>
                            <tr>
                                <SearchField allowSearch={this.state.loading} value={this.state.searchValue} onValueChange={this.handleValueChange} placeholder="Buscar Pedido" />                            </tr>
                            <tr>
                                <td>
                                    {/* Fila de Tabs y Filtros de búsqueda */}
                                    <Box sx={{ 
                                        display: 'flex', 
                                        justifyContent: 'space-between', 
                                        alignItems: 'flex-start',
                                        flexDirection: { xs: 'column', md: 'row' },
                                        gap: '10px',
                                        bgcolor: 'background.paper', 
                                        marginLeft: '10px', 
                                        marginTop: '5px'
                                    }}>
                                        {/* Tabs a la izquierda */}
                                        <Tabs
                                            value={tabPedidos}
                                            onChange={this.handleChangeTab}
                                            aria-label="tabs pedidos"
                                        >
                                            <Tab label={`Pendientes`} />
                                            <Tab label={`Todos`} />
                                            {this.props.type === 1 && <Tab label={`Histórico`} />}
                                        </Tabs>
                                        
                                        {/* Filtros de búsqueda a la derecha - solo visible en tab Histórico */}
                                        {this.props.type === 1 && tabPedidos === 2 && (
                                            <Box sx={{ 
                                                display: 'flex', 
                                                flexDirection: 'column',
                                                gap: { xs: '8px', md: '0' },
                                                padding: { xs: '6px 8px', md: '8px 12px' },
                                                backgroundColor: '#f5f5f5',
                                                borderRadius: '4px',
                                                marginRight: { xs: '0', md: '15px' },
                                                width: { xs: '100%', md: 'auto' }
                                            }}>
                                                {/* Desktop: todo en una línea incluyendo el texto */}
                                                <Box sx={{ 
                                                    display: { xs: 'none', md: 'flex' },
                                                    alignItems: 'center',
                                                    gap: '10px'
                                                }}>
                                                    <span style={{ fontSize: '13px', color: '#284770', whiteSpace: 'nowrap' }}>
                                                        Buscar por Granja y/o Lote:
                                                    </span>
                                                    {/* Selector de Granja */}
                                                    <Autocomplete
                                                        id="granja-autocomplete-desktop"
                                                        options={Array.isArray(this.state.historicoGranjas) ? this.state.historicoGranjas : []}
                                                        getOptionLabel={(option) => option.name || ''}
                                                        value={this.state.historicoGranjas.find(g => g.id === this.state.historicoGranja) || null}
                                                        onChange={this.handleHistoricoGranjaChange}
                                                        disabled={this.state.loadingHistorico}
                                                        loading={this.state.loadingHistorico}
                                                        size="small"
                                                        sx={{ minWidth: 180 }}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                label="Granja"
                                                                variant="standard"
                                                                placeholder="Todas"
                                                                InputProps={{
                                                                    ...params.InputProps,
                                                                    endAdornment: (
                                                                        <>
                                                                            {this.state.loadingHistorico ? <CircularProgress color="inherit" size={16} /> : null}
                                                                            {params.InputProps.endAdornment}
                                                                        </>
                                                                    ),
                                                                }}
                                                            />
                                                        )}
                                                        noOptionsText="Sin resultados"
                                                        clearText="Limpiar"
                                                        openText="Abrir"
                                                        closeText="Cerrar"
                                                    />

                                                    {/* Selector de Lote */}
                                                    <Autocomplete
                                                        id="lote-autocomplete-desktop"
                                                        options={Array.isArray(this.state.historicoLotesDisponibles) 
                                                            ? this.state.historicoLotesDisponibles.filter(l => !this.state.historicoGranja || l.farmId === this.state.historicoGranja)
                                                            : []}
                                                        getOptionLabel={(option) => option.batchId || ''}
                                                        value={this.state.historicoLotesDisponibles.find(l => l.batchId === this.state.historicoLote) || null}
                                                        onChange={this.handleHistoricoLoteChange}
                                                        disabled={this.state.loadingHistorico}
                                                        loading={this.state.loadingHistorico}
                                                        size="small"
                                                        sx={{ minWidth: 140 }}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                label="Lote"
                                                                variant="standard"
                                                                placeholder="Todos"
                                                                InputProps={{
                                                                    ...params.InputProps,
                                                                    endAdornment: (
                                                                        <>
                                                                            {this.state.loadingHistorico ? <CircularProgress color="inherit" size={16} /> : null}
                                                                            {params.InputProps.endAdornment}
                                                                        </>
                                                                    ),
                                                                }}
                                                            />
                                                        )}
                                                        noOptionsText="Sin resultados"
                                                        clearText="Limpiar"
                                                        openText="Abrir"
                                                        closeText="Cerrar"
                                                    />

                                                    {/* Fechas */}
                                                    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
                                                        <DatePicker
                                                            label="Desde"
                                                            value={this.state.historicoDateFrom}
                                                            onChange={this.handleHistoricoDateFromChange}
                                                            format="dd/MM/yyyy"
                                                            style={{ width: '90px' }}
                                                        />
                                                        <DatePicker
                                                            label="Hasta"
                                                            value={this.state.historicoDateTo}
                                                            onChange={this.handleHistoricoDateToChange}
                                                            format="dd/MM/yyyy"
                                                            style={{ width: '90px' }}
                                                        />
                                                    </MuiPickersUtilsProvider>

                                                    {/* Botón Aplicar */}
                                                    <Button 
                                                        variant="outlined" 
                                                        onClick={this.handleBuscarHistorico}
                                                        disabled={this.state.loadingHistorico}
                                                        size="small"
                                                        sx={{ 
                                                            fontSize: '0.75rem',
                                                            padding: '4px 12px',
                                                            whiteSpace: 'nowrap'
                                                        }}
                                                    >
                                                        {this.state.loadingHistorico ? (
                                                            <CircularProgress size={16} color="inherit" />
                                                        ) : (
                                                            'Aplicar'
                                                        )}
                                                    </Button>
                                                    <Tooltip title="Restablecer filtros">
                                                        <span>
                                                            <IconButton 
                                                                onClick={this.handleLimpiarFiltrosHistorico}
                                                                disabled={this.state.loadingHistorico}
                                                                size="small"
                                                                sx={{ color: '#284770' }}
                                                            >
                                                                {this.state.loadingHistorico ? (
                                                                    <CircularProgress size={16} color="inherit" />
                                                                ) : (
                                                                    <RefreshIcon fontSize="small" />
                                                                )}
                                                            </IconButton>
                                                        </span>
                                                    </Tooltip>
                                                </Box>

                                                {/* Mobile: Línea 1 - Granja, Lote, Buscar */}
                                                <Box sx={{ 
                                                    display: { xs: 'flex', md: 'none' },
                                                    alignItems: 'center',
                                                    gap: '6px',
                                                    width: '100%',
                                                    boxSizing: 'border-box'
                                                }}>
                                                    {/* Selector de Granja */}
                                                    <Autocomplete
                                                        id="granja-autocomplete-mobile"
                                                        options={Array.isArray(this.state.historicoGranjas) ? this.state.historicoGranjas : []}
                                                        getOptionLabel={(option) => option.name || ''}
                                                        value={this.state.historicoGranjas.find(g => g.id === this.state.historicoGranja) || null}
                                                        onChange={this.handleHistoricoGranjaChange}
                                                        disabled={this.state.loadingHistorico}
                                                        loading={this.state.loadingHistorico}
                                                        size="small"
                                                        sx={{ flex: 1, minWidth: 0 }}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                label="Granja"
                                                                variant="standard"
                                                                placeholder="Todas"
                                                                InputProps={{
                                                                    ...params.InputProps,
                                                                    endAdornment: (
                                                                        <>
                                                                            {this.state.loadingHistorico ? <CircularProgress color="inherit" size={14} /> : null}
                                                                            {params.InputProps.endAdornment}
                                                                        </>
                                                                    ),
                                                                }}
                                                            />
                                                        )}
                                                        noOptionsText="Sin resultados"
                                                        clearText="Limpiar"
                                                        openText="Abrir"
                                                        closeText="Cerrar"
                                                    />

                                                    {/* Selector de Lote */}
                                                    <Autocomplete
                                                        id="lote-autocomplete-mobile"
                                                        options={Array.isArray(this.state.historicoLotesDisponibles) 
                                                            ? this.state.historicoLotesDisponibles.filter(l => !this.state.historicoGranja || l.farmId === this.state.historicoGranja)
                                                            : []}
                                                        getOptionLabel={(option) => option.batchId || ''}
                                                        value={this.state.historicoLotesDisponibles.find(l => l.batchId === this.state.historicoLote) || null}
                                                        onChange={this.handleHistoricoLoteChange}
                                                        disabled={this.state.loadingHistorico}
                                                        loading={this.state.loadingHistorico}
                                                        size="small"
                                                        sx={{ flex: 1, minWidth: 0 }}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                label="Lote"
                                                                variant="standard"
                                                                placeholder="Todos"
                                                                InputProps={{
                                                                    ...params.InputProps,
                                                                    endAdornment: (
                                                                        <>
                                                                            {this.state.loadingHistorico ? <CircularProgress color="inherit" size={14} /> : null}
                                                                            {params.InputProps.endAdornment}
                                                                        </>
                                                                    ),
                                                                }}
                                                            />
                                                        )}
                                                        noOptionsText="Sin resultados"
                                                        clearText="Limpiar"
                                                        openText="Abrir"
                                                        closeText="Cerrar"
                                                    />

                                                    {/* Contenedor del Botón Buscar centrado */}
                                                    <Box sx={{ flex: 1, display: 'flex', justifyContent: 'center', minWidth: 0 }}>
                                                        <Tooltip title="Buscar">
                                                            <span>
                                                                <IconButton 
                                                                    onClick={this.handleBuscarHistorico}
                                                                    disabled={this.state.loadingHistorico}
                                                                    size="small"
                                                                    sx={{ 
                                                                        color: '#284770',
                                                                        border: '1px solid #284770',
                                                                        borderRadius: '4px',
                                                                        padding: '5px',
                                                                        '&:hover': {
                                                                            backgroundColor: 'rgba(40, 71, 112, 0.08)'
                                                                        }
                                                                    }}
                                                                >
                                                                    {this.state.loadingHistorico ? (
                                                                        <CircularProgress size={18} color="inherit" />
                                                                    ) : (
                                                                        <SearchIcon fontSize="small" />
                                                                    )}
                                                                </IconButton>
                                                            </span>
                                                        </Tooltip>
                                                    </Box>
                                                </Box>

                                                {/* Mobile: Línea 2 - Desde, Hasta, Limpiar */}
                                                <Box sx={{ 
                                                    display: { xs: 'flex', md: 'none' },
                                                    alignItems: 'center',
                                                    gap: '6px',
                                                    width: '100%',
                                                    boxSizing: 'border-box'
                                                }}>
                                                    <Box sx={{ flex: 1, minWidth: 0 }}>
                                                        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
                                                            <DatePicker
                                                                label="Desde"
                                                                value={this.state.historicoDateFrom}
                                                                onChange={this.handleHistoricoDateFromChange}
                                                                format="dd/MM/yyyy"
                                                                style={{ width: '100%' }}
                                                            />
                                                        </MuiPickersUtilsProvider>
                                                    </Box>
                                                    <Box sx={{ flex: 1, minWidth: 0 }}>
                                                        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
                                                            <DatePicker
                                                                label="Hasta"
                                                                value={this.state.historicoDateTo}
                                                                onChange={this.handleHistoricoDateToChange}
                                                                format="dd/MM/yyyy"
                                                                style={{ width: '100%' }}
                                                            />
                                                        </MuiPickersUtilsProvider>
                                                    </Box>
                                                    {/* Contenedor del Botón Limpiar centrado */}
                                                    <Box sx={{ flex: 1, display: 'flex', justifyContent: 'center', minWidth: 0 }}>
                                                        <Tooltip title="Restablecer filtros">
                                                            <span>
                                                                <IconButton 
                                                                    onClick={this.handleLimpiarFiltrosHistorico}
                                                                    disabled={this.state.loadingHistorico}
                                                                    size="small"
                                                                    sx={{ 
                                                                        color: '#284770',
                                                                        border: '1px solid #284770',
                                                                        borderRadius: '4px',
                                                                        padding: '5px',
                                                                        '&:hover': {
                                                                            backgroundColor: 'rgba(40, 71, 112, 0.08)'
                                                                        }
                                                                    }}
                                                                >
                                                                    {this.state.loadingHistorico ? (
                                                                        <CircularProgress size={18} color="inherit" />
                                                                    ) : (
                                                                        <RefreshIcon fontSize="small" />
                                                                    )}
                                                                </IconButton>
                                                            </span>
                                                        </Tooltip>
                                                    </Box>
                                                </Box>
                                            </Box>
                                        )}
                                    </Box>

                                    {/* Sección de Visualización - separada, debajo de los filtros */}
                                    {this.props.type === 1 && tabPedidos === 2 && this.state.pedidosHistorico && this.state.pedidosHistorico.length > 0 && (
                                        <Box sx={{ 
                                            display: 'flex', 
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            gap: { xs: '5px', md: '15px' },
                                            marginLeft: '10px',
                                            marginTop: '10px',
                                            padding: { xs: '6px 10px', md: '10px 15px' },
                                            backgroundColor: '#e3f2fd',
                                            borderRadius: '4px',
                                            borderLeft: '4px solid #284770'
                                        }}>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: '5px', md: '10px' } }}>
                                                {/* Texto solo visible en desktop */}
                                                <Box sx={{ display: { xs: 'none', md: 'block' } }}>
                                                    <span style={{ fontSize: '13px', color: '#284770' }}>
                                                        Visualización:
                                                    </span>
                                                </Box>
                                                <FormControl variant="standard" sx={{ minWidth: { xs: 120, md: 150 } }}>
                                                    <Select
                                                        id="agrupado-select"
                                                        value={this.state.historicoAgrupado}
                                                        onChange={this.handleHistoricoAgrupadoChange}
                                                        size="small"
                                                    >
                                                        <MenuItem value="pedido">Por pedido</MenuItem>
                                                        <MenuItem value="granja">Agrupar por granja</MenuItem>
                                                        <MenuItem value="lote">Agrupar por lote</MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </Box>
                                            {/* Texto descripción solo visible en desktop */}
                                            <Box sx={{ display: { xs: 'none', md: 'block' } }}>
                                                <span style={{ fontSize: '13px', color: '#284770' }}>
                                                    {this.getDescripcionResultados()}
                                                </span>
                                            </Box>
                                        </Box>
                                    )}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <Box sx={{
                    position: 'absolute',
                    top: (this.props.type === 1 && tabPedidos === 2) 
                        ? (this.state.pedidosHistorico && this.state.pedidosHistorico.length > 0)
                            ? { xs: 310, md: 220 }  // Histórico con resultados: tabs + filtros (2 líneas mobile) + visualización
                            : { xs: 250, md: 160 }  // Histórico sin resultados: tabs + filtros (2 líneas mobile)
                        : 130,
                    left: 0,
                    right: 0,
                    bottom: 0,
                }}>
                    {this.renderPedidos(type)}
                </Box>

                {this.state.openDeliveryDialog?
                    <CreateModal
                        onCloseCreationModal={this.onCloseDeliveryDialog}
                        isOpen={this.state.openDeliveryDialog}
                        inputText={this.state.inputDeliveryDialog}
                        typeModal={this.state.modalType}
                        action={this.handleCreateModal}
                        typeAction={this.state.typeAction}
                        loadingModal={this.state.loadingModal}
                        titleModal={this.state.titleModal}
                        zIndex={0}
                    />
                :
                    null
                }
                {this.state.creationModalOpen?
                    <CreateModal
                        onCloseCreationModal={this.onCloseCreationModal}
                        isOpen={this.state.creationModalOpen}
                        inputText={this.state.inputText}
                        typeModal={this.state.modalType}
                        action={this.handleCreateModal}
                        typeAction={this.state.typeAction}
                        loadingModal={this.state.loadingModal}
                        titleModal={this.state.titleModal}
                        zIndex={99}
                    />
                :
                    null
                }
            </AppBar>
        );
    }
}
export default withParamsAndNavigate(Pedidos);